import { render, staticRenderFns } from "./EditProviderRegion.vue?vue&type=template&id=73d1a5a2"
import script from "./EditProviderRegion.vue?vue&type=script&lang=js"
export * from "./EditProviderRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports